import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { TextV2 } from 'src/components/TextV2/TextV2';

import styles from './CheckoutLoading.scss';

export const CheckoutLoading: React.FC<{}> = () => {
  const { t } = useTranslation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  }, []);

  return (
    <div className={styles.loadingContainer}>
      <TextV2
        className={styles.loadingContainerHeading}
        tagName="h2"
        variant="h2-bold"
        value={t('checkout-loading.heading')}
      />
      <TextV2
        tagName="p"
        variant="body"
        value={t('checkout-loading.description')}
      />
    </div>
  );
};
